// import { createAction } from '@reduxjs/toolkit'

function CreateAction(type, callback) {
  function action(...params) {
    const obj = { type }
    if (callback) {
      obj.payload = callback(...params)
    }
    return obj
  }
  action.type = type

  return action
}
// const CreateAction = (name, callback) => {
//   if (!callback) return createAction(name)
//   return createAction(name, (...params) => ({ payload: callback(...params) }))
// }

export default CreateAction
